import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faSearch, faXmark} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-search-input',
  imports: [FormsModule, FaIconComponent],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.css'
})
export class SearchInputComponent {
  @Input() searchText = '';
  @Input() placeholder = '';
  @Input() buttonText = 'Пребарај';
  @Output() searchTextChange = new EventEmitter<string>();
  @Output() search = new EventEmitter<void>();

  faSearch = faSearch;
  faXmark = faXmark;

  clearSearch(): void {
    this.searchText = '';
    this.searchTextChange.emit('');
    this.search.emit();
  }
}
